/*
 * COMBASE会員限定商品 - Cookie読み取り基盤 (WEB-1097 / 実装内容A)
 *
 * FC(別サイト)から流入したユーザーには、App Proxy経由でCookie `fc_token` が
 * 発行される。このスクリプトはそのCookieを読み取り、FC会員かどうかを判定する
 * 共通APIを提供する。全ページ(theme.liquid)で読み込まれる。
 */
(function () {
  "use strict";

  /**
   * Cookie `fc_token` を読み取る。
   * @returns {string|null} トークン文字列。存在しなければ null。
   */
  function getFcToken() {
    var match = document.cookie.match(/(?:^|;\s*)fc_token=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  /**
   * FC会員かどうかを判定する(全ページで使用)。
   * @returns {boolean}
   */
  function isFcMember() {
    return !!getFcToken();
  }

  // 全ページから参照できるようグローバルに公開する。
  window.getFcToken = getFcToken;
  window.isFcMember = isFcMember;

  // CSSからの表示制御用に、ルート要素へFC会員状態を表すクラスを付与する。
  // defer 実行のため <html> は既にパース済みで、即時付与してFOUCを防ぐ。
  var rootClass = isFcMember() ? "fc-member" : "fc-guest";
  document.documentElement.classList.add(rootClass);

  /**
   * 商品詳細ページのカートボタン出し分け (WEB-1096)。
   *
   * 全商品がCOMBASE会員限定のため、商品詳細ページには常に以下が
   * 出力されている(WEB-1095):
   *   - [data-fc-member-buy]     … 数量選択 + カートに追加(会員向け / 既定表示)
   *   - [data-fc-non-member-buy] … FCログイン誘導(非会員向け / 既定 hidden)
   *
   * 非会員のときだけ会員向けUIを隠し、非会員向けUIを表示する。
   * 会員・通常商品(ゲート要素なし)は既定表示のまま何もしない。
   * JS無効時は会員向けUIが表示される(注意事項の許容範囲)。
   */
  function applyFcBuyGate() {
    var gate = document.querySelector("[data-fc-buy-gate]");
    if (!gate) return; // ゲート要素が無いページ(商品詳細以外)

    if (isFcMember()) return; // 会員は通常通りカートボタンを表示

    // 非会員: 会員向けUI(カートボタン・数量選択)を隠す
    var memberEls = document.querySelectorAll("[data-fc-member-buy]");
    for (var i = 0; i < memberEls.length; i++) {
      memberEls[i].hidden = true;
    }

    // 非会員向けUI(FCログイン誘導)を表示する
    var nonMember = gate.querySelector("[data-fc-non-member-buy]");
    if (nonMember) {
      nonMember.hidden = false;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFcBuyGate);
  } else {
    applyFcBuyGate();
  }
})();
